import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  FiHome, 
  FiShoppingBag, 
  FiFolder, 
  FiTool, 
  FiUsers, 
  FiSettings,
  FiChevronLeft,
  FiChevronRight,
  FiLogOut,
  FiFileText
} from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import { toast } from 'react-hot-toast';

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();

  const menuItems = [
    { path: '/admin', icon: FiHome, label: 'ទំព័រដើម', labelEn: 'Dashboard' },
    { path: '/admin/products', icon: FiShoppingBag, label: 'ផលិតផល', labelEn: 'Products' },
    { path: '/admin/categories', icon: FiFolder, label: 'ប្រភេទ', labelEn: 'Categories' },
    { path: '/admin/repairs', icon: FiFileText, label: 'អត្ថបទ', labelEn: 'Repair Articles' },
    
  ];

  const handleLogout = () => {
    logout();
    toast.success('ចាកចេញដោយជោគជ័យ');
    navigate('/login');
  };

  return (
    <div className={`bg-gray-900 text-white ${collapsed ? 'w-20' : 'w-64'} transition-all duration-300 flex flex-col`}>
      {/* Logo */}
      <div className="flex items-center justify-between p-4 border-b border-gray-800">
        {!collapsed && (
          <img src='/logo11.png'></img>
        )}
        <button
          onClick={() => setCollapsed(!collapsed)}
          className="p-2 hover:bg-gray-800 transition-colors"
        >
          {collapsed ? <FiChevronRight size={20} /> : <FiChevronLeft size={20} />}
        </button>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-4">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center px-4 py-3 mb-1 transition-colors ${
                isActive 
                  ? 'bg-red-600 text-white' 
                  : 'text-gray-300 hover:bg-gray-800 hover:text-red-400'
              }`
            }
          >
            <item.icon className="w-5 h-5" />
            {!collapsed && <span className="ml-3">{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      {/* Logout */}
      <div className="border-t border-gray-800 p-4">
        <button
          onClick={handleLogout}
          className="flex items-center text-gray-300 hover:text-red-400 w-full transition-colors"
        >
          <FiLogOut className="w-5 h-5" />
          {!collapsed && <span className="ml-3">ចាកចេញ</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;